import { Link } from "react-router-dom";
import { Phone, Mail, Globe, Linkedin } from "lucide-react";
import kortimed from "@/assets/kortimed.webp";
import sgs from "@/assets/sgs.webp";
import TTS from "@/assets/TTS.webp";
import OLIVIKI from "@/assets/OLIVIKI.webp";
import ONS from "@/assets/ONS.webp";


const footerLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Products", path: "/products" },
  { label: "Quality & Sourcing", path: "/quality" },
  { label: "Export Services", path: "/export" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];
const partners = [
  { src: kortimed, alt: "Kortimed", desc: "Reliable bulk liquid transport and logistics solutions." },
  { src: sgs, alt: "SGS", desc: "International inspection, testing and certification services." },
  { src: TTS, alt: "TTS", desc: "Industrial fluid handling and technical solutions." },
  { src: OLIVIKI, alt: "OLIVIKI", desc: "Partner mill – Based in Béja & Sfax." },
  { src: ONS, alt: "ONS", desc: "Partner mill – Based in Sidi Bouzid." },
];

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      {/* --- SECTION PARTENAIRES --- */}
<div className="bg-white border-b border-gray-200 py-10 overflow-hidden relative"> {/* Increased py to 20 */}
  <div className="animate-partners flex items-center gap-16 md:gap-32 px-4">
    {[1, 2, 3, 4].map((groupIndex) => (
      <div key={groupIndex} className="flex items-center gap-16 md:gap-32">
        {partners.map((partner, i) => (
          <div key={i} className="relative group flex flex-col items-center">
            
            <img fetchPriority="high" loading="eager"
              src={partner.src} 
              alt={partner.alt} 
              className="h-10 md:h-14 transition-transform hover:scale-105 duration-300 object-contain cursor-help" 
            />

            {/* Tooltip positioned BELOW the logo */}
            <div className="absolute top-full mt-2 hidden group-hover:block w-40 bg-gray-800 text-white text-[10px] py-1 px-2 rounded shadow-xl text-center z-50 pointer-events-none whitespace-normal">
              {partner.desc}
              {/* Arrow pointing UP */}
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 border-8 border-transparent border-b-gray-800"></div>
            </div>
            
          </div>
        ))}
      </div>
    ))}
  </div>
</div>
   <div className="container-max px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="font-heading text-2xl font-bold mb-3">MM2A</h3>
            <p className="text-primary-foreground text-sm leading-relaxed">
            Supplying bulk olive oil to international importers, bottlers, distributors, refiners, and industrial buyers. Consistent quality. Full traceability. Direct from Tunisia.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Navigation</h4>
            <div className="flex flex-col gap-2">
              {footerLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-primary-foreground hover:text-primary-foreground transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

         <div>
  <h4 className="font-heading text-lg font-semibold mb-4">Contact</h4>
  <div className="flex flex-col gap-3 text-sm text-primary-foreground">
    <p className="flex items-center gap-2">
      Sfax, Tunisia
    </p>
    
    {/* WhatsApp Contact */}
    <a 
      href="https://wa.me/21626677428" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="flex items-center gap-2 hover:text-primary-foreground transition-colors"
    >
      <Phone className="size-4" />
      +216 26 677 428
    </a>

    {/* Email */}
    <a 
      href="mailto:contact@mm2a.net" 
      className="flex items-center gap-2 hover:text-primary-foreground transition-colors"
    >
      <Mail className="size-4" />
      contact@mm2a.net
    </a>
{/* LinkedIn */}
  <a 
    href="https://www.linkedin.com/company/mm2a-tunisian-export/" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="flex items-center gap-2 hover:text-primary-foreground transition-colors"
  >
    <Linkedin className="size-4" />
    MM2A tunisian export
  </a>
    {/* Website */}
    <a 
      href="https://www.mm2a.net" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="flex items-center gap-2 hover:text-primary-foreground transition-colors"
    >
      <Globe className="size-4" />
      www.mm2a.net
    </a>
  </div>
</div>
        </div>

<div className="border-t border-primary-foreground/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
  <div className="flex flex-col gap-1">
    <p className="text-sm text-primary-foreground/60">
      © {new Date().getFullYear()} MM2A Tunisian Export — All rights reserved
    </p>
    <p className="text-[11px] text-primary-foreground/70 italic">
      Developed by{' '}
<a 
  href="https://www.linkedin.com/in/bouaziz-mohamed/" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="relative font-semibold text-amber-600 hover:text-amber-700 transition-colors duration-300 after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-amber-600 after:origin-bottom-right hover:after:scale-x-100 hover:after:origin-bottom-left after:transition-transform after:duration-300 pb-0.5"
>
  Mohamed Bouaziz
</a>
    </p>
  </div>

  <p className="text-sm text-primary-foreground/60 text-center md:text-right">
    Professional olive oil supply from Tunisia for international buyers.
  </p>
</div>
      </div>
    </footer>
  );
};

export default Footer;
